module.exports = __webpack_public_path__ + "img/848-27b498.png";